import React, { Component } from 'react';
import AdminFilteredContentList from './Admin_FilteredContentList';

class RegionsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRegion: "",

        };
    }


    handleFilterChange = (event) => {

        let value = event.target.value;


        this.setState({ selectedRegion: value });
    };

    render() {
        const {
            filter,
            regions,
            onSelectRegion,
            onNewRegions,
        } = this.props;

        return (
            <div className='admin_list'>
                <button onClick={onNewRegions}>Create New Region</button>

                <AdminFilteredContentList
                    filter={filter}
                    getKey={(item, index) => item.id || item.Id || index}
                    kind="region"
                    records={regions}
                    renderRecord={item => (
                        <button
                            className="listElement"
                            onClick={() => onSelectRegion(item)}
                            type="button"
                        >
                            {item.name ?? item.Name}
                        </button>
                    )}
                />


            </div>
        );
    }
}

export default RegionsList;
